import { useEffect, useState } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Bootcamps from "@/components/site/Bootcamps";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CoffeeSection from "@/components/site/CoffeeSection";
import CoffeeConcierge from "@/components/site/CoffeeConcierge";
import axios from "axios";
import { API_BASE } from "@/lib/api";

export default function Landing() {
  const [bootcamps, setBootcamps] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE}/bootcamps`)
      .then((r) => setBootcamps(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F5F0] text-[#2D372B]">
      <Nav />
      <Hero />
      <About />
      <Services />
      <Bootcamps bootcamps={bootcamps} refresh={() => axios.get(`${API_BASE}/bootcamps`).then((r) => setBootcamps(r.data))} />
      <Testimonials />
      <Contact />
      <CoffeeSection />
      <CoffeeConcierge />
      <Footer />
    </div>
  );
}
